import React from 'react';
import {Link as RouterLink} from 'react-router-dom';
import {
    ListItem,
    ListItemIcon,
    ListItemText
} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import PropTypes from 'prop-types';
import { isMobile } from 'react-device-detect';

const useStyles = makeStyles(theme => ({
    listItemIcon: {
        color: 'black',
        "& img": {
            width: '30px',
            marginLeft: '2px'
        },
    },
    blackListItemText: {
        color: 'black',
        fontSize: '1rem',
        fontWeight: '700',
        paddingLeft: '10px',
        marginLeft: '-35px'
    },
    grayListItemText: {
        color: 'gray',
        fontSize: '1rem',
        fontWeight: '700',
        paddingLeft: '10px',
        marginLeft: '-35px'
    },
}));

function ListItemLink(props) {
    const {icon, primary, secondary, to, classname, isNested, isArrow, noIcon, isClick} = props;
    const classes = useStyles();
    const renderLink = React.useMemo(
        () => React.forwardRef((itemProps, ref) => <RouterLink to={to} ref={ref} {...itemProps} replace/>),
        [to],
    );
    
    return (
        <ListItem button component={to ? renderLink : null} onClick={props.onClick} className={classname}
                  divider={isMobile !== null}>
            {icon ?
                <ListItemIcon className={classes.listItemIcon}>{icon}</ListItemIcon> :
                noIcon ? null : 
                <ListItemIcon className={classes.listItemIcon}/>
            }
            {isNested ?
                <ListItemText primary={primary} secondary={secondary}/> :
                isClick ?
                    <ListItemText primary={primary} secondary={secondary} classes={{primary: classes.blackListItemText}}/> :
                    <ListItemText primary={primary} secondary={secondary} classes={{primary: classes.grayListItemText}}/>
            }
            {(isMobile || isArrow) && <ChevronRightIcon/>}
        </ListItem>
    );
}

ListItemLink.defaultProps = {
    icon: undefined,
    primary: 'Link',
    secondary: '',
    to: '/',
    classname: '',
    isNested: false,
    isArrow: false,
    noIcon: false,
    onClick: () => {}
};

ListItemLink.propTypes = {
    icon: PropTypes.element,
    primary: PropTypes.string.isRequired,
    secondary: PropTypes.string,
    to: PropTypes.string.isRequired,
    classname: PropTypes.string,
    isNested: PropTypes.bool,
    isArrow: PropTypes.bool,
    noIcon: PropTypes.bool,
    onClick: PropTypes.func
};

export default ListItemLink;
